// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__rO_eu","header":"ClearentDisclaimer_header__NslrQ","inner":"ClearentDisclaimer_inner__3KKdM"};